import { Column } from "@/components/Table/Table";

export const EMPLOYEE_BUSINESS_TRAVEL_UPLOAD_COLUMNS: Column[] = [
  {
    label: "Travel ID",
    key: "external_id",
    searchable: true,
    minWidth: "170px",
  },
  {
    label: "date",
    key: "date",
    sortable: true,
  },
  {
    label: "Departure",
    key: "departure",
    searchable: true,
    minWidth: "168px",
  },
  {
    label: "Arrival",
    key: "arrival",
    searchable: true,
    minWidth: "168px",
  },
  {
    label: "Travel mode",
    key: "travel_mode",
    searchable: true,
    minWidth: "170px",
  },
  {
    label: "Total km",
    key: "distance",
    sortable: true,
    minWidth: "140px",
  },
  {
    label: "Owned or leased",
    key: "owned",
    sortable: true,
    minWidth: "200px",
  },
];
